const getBaseUrl = () => {
    const currentDomain = window.location.hostname;
    if(currentDomain === 'localhost'){
        return 'http://localhost:5000'; 
    }else{
        return `https://api.akhanddairy.com`;
    }
};

const baseUrl = getBaseUrl();
const limit = 20;
const dashboardLimit = 10;

const purchaseProductList = [
    {value : 1, label : "Milk"},
    {value : 2, label : "Other"},
];
const milkType = [
    {value : 1, label : "Cow Milk"},
    {value : 2, label : "Buffalo Milk"},
];
const sellType = [
    {value : 1, label : "Store"},
    {value : 2, label : "App"},
]

const shopFixCostCategory = [
    {value : 1, label : "Rent"},
    {value : 2, label : "Electricity Bill"},
    {value : 3, label : "Packaging Materials"},
    {value : 4, label : "Petrol"},
    {value : 5, label : "Gas Bill"},
    {value : 6, label : "Other"},
]

const shopFixCostPetrol = [
    {value : 1, label : "Milk Man"},
    {value : 2, label : "Other"},
];

const labourType = [
    {value : 1, label : "Farm"},
    {value : 2, label : "Agriculture"},
    {value : 3, label : "Construction"},
];

const animalType =[
    {value : 1, label : "Cow"},
    {value : 2, label : "Buffalo"},
];

const productType = [
    {value : 1, label : "Medicin", company_type : 1},
    {value : 2, label : "Dhan", company_type : 1},
    {value : 3, label : "Charo", company_type : 1},
    {value : 7, label : "Milk", company_type : 1},
    {value : 4, label : "Seed", company_type : 2},
    {value : 5, label : "Fertilizer", company_type : 2},
    {value : 8, label : "Sell", company_type : 2},
    {value : 6, label : "Row Material", company_type : 3},
    
    
];

const fuelType = [
    {value: 1, label: "Petrol"},
    {value: 2, label: "Diesel"},
];

const usageType = [
    {value: 1, label: "Transportation"},
    {value: 2, label: "On Field"},
];

const feedProductType = [
    {value: 1, label: "Dhaan"},
    {value: 2, label: "Charo"},
];

const agricultureFeedProductType = [
    {value: 1, label: "Seeds"},
    {value: 2, label: "Fertilizer"},
]

const otherType = [
    {value: 1, label: "Cost"},
    {value: 2, label: "Income"},
];

const buySellType = [
    {value: 1, label: "Sell"},
    {value: 2, label: "Purchase"},
]

export {baseUrl, limit, dashboardLimit, purchaseProductList, milkType,sellType, shopFixCostCategory, shopFixCostPetrol, labourType, animalType, productType, fuelType, usageType, feedProductType, otherType, agricultureFeedProductType, buySellType};